"use client";

import { useActionState } from "react";
import Link from "next/link";

import { type MuniRequestState, requestMuniAccessAction } from "@/app/actions/muni-requests";

/** "Ny kommune? Be om tilgang": municipalities ask for access themselves. */
export function AccessRequestForm() {
  const [state, formAction, pending] = useActionState<MuniRequestState, FormData>(
    requestMuniAccessAction,
    {}
  );

  return (
    <div className="mx-login-section">
      <p className="mx-login-section-label">Ny kommune? Be om tilgang</p>
      {state.success ? (
        <p className="mx-login-sent">
          Takk! Vi har mottatt forespørselen. Når den er godkjent, får du en e-post med lenke for å
          logge inn. Har adressen allerede tilgang, får du innloggingslenken med en gang.
        </p>
      ) : (
        // React clears a form after its action runs; the values come back from
        // the action so an error doesn't wipe what was typed.
        <form action={formAction} className="mx-login-magic-form">
          <input
            aria-label="Kommune"
            className="mx-login-input"
            defaultValue={state.values?.municipality}
            maxLength={80}
            name="municipality"
            placeholder="Kommune, f.eks. Bodø"
            required
          />
          <input
            aria-label="Navn"
            autoComplete="name"
            className="mx-login-input"
            defaultValue={state.values?.contactName}
            maxLength={80}
            name="contactName"
            placeholder="Ditt navn"
          />
          <input
            aria-label="E-post"
            autoComplete="email"
            className="mx-login-input"
            defaultValue={state.values?.email}
            name="email"
            placeholder="din@kommune.no"
            required
            type="email"
          />
          {/* Honeypot: hidden from people, filled in by bots. */}
          <input
            aria-hidden="true"
            autoComplete="off"
            name="hp_leave_empty"
            style={{ display: "none" }}
            tabIndex={-1}
          />
          {state.error && <p className="mx-login-error">{state.error}</p>}
          <button className="mx-login-magic-btn" disabled={pending} type="submit">
            {pending ? "Sender…" : "Be om tilgang"}
          </button>
        </form>
      )}
      <Link className="mx-login-switch" href="/login">
        ← Tilbake til innlogging
      </Link>
    </div>
  );
}
